export const ATS_DESCRIPCION_DETALLES = [
    {
        "descripcion_pasos_de_tarea":"Revisar la orden de instalación Trasladar al lugar de trabajo para inicio de actividades.",
        "riesgos_seguridad_salud":[
            "Atrapamiento por vuelco o choque de vehículos.",
            "Atropello o golpe por vehículos."
        ],
        "medidas_de_control":[
            ["Inspeccionar el vehículo antes de su uso. ",true],
            ["Respetar los límites de velocidad establecidos en la Ley de Tránsito. ",true],
            ["Manejar siempre a la defensiva. ",true],
            ["El vehículo cuenta con su respectivo programa de mantenimiento.",true],
            ["Aprobación de revisión vehicular y matrícula vigente. ",true],
            ["El vehículo cuenta con llanta de emergencia, botiquín de primeros auxilios y extintor. ",true],
            ["Realizar prueba de alcoholemia al personal.",true],
            ["Utilizar el EPP (calzado de seguridad) y ropa de trabajo adecuada (100% algodón).",true],
        ]
    },
    {
        "descripcion_pasos_de_tarea":"Cargar herramientas y equipos para dirigirse al lugar de trabajo.",
        "riesgos_seguridad_salud":[
            "Caída de objetos en manipulación",
            "Golpes, cortes por objetos/ herramientas",
            "Atrapamiento por o entre objetos",
            "Levantamiento manual de cargas",
            "Sobreesfuerzo físico"
        ],
        "medidas_de_control":[
            ["Utilizar calzado de seguridad. ",true],
            ["Utilizar guantes. ",true],
            ["Levantar la carga adecuadamente. ",true],
            ["Cargas superiores a 23kg levantar mínimo entre dos personas. ",true],
            ["Colocar cuñas en la bobina de cable y en la porta bobinas en el momento de su manipulación.",true],
        ]
    },
    {
        "descripcion_pasos_de_tarea": "Señalizar el área de trabajo",
        "riesgos_seguridad_salud": [
          "Atropello o golpe por vehículos"
        ],
        "medidas_de_control": [
          ["Colocarse el EPP (guantes, casco de seguridad con barbiquejo, calzado de seguridad dieléctrico, chaleco reflectivo, con cintas reflectantes color verde o naranja).",true],
          ["Señalizar el área de trabajo guardando distancias de seguridad.",true],
          ["Utilizar conos de seguridad 90cm de alto mínimo (4 conos/ grupo mínimo).",true],
        ]
    },
    {
        "descripcion_pasos_de_tarea": "Descargar equipos y herramientas para realizar el trabajo.",
        "riesgos_seguridad_salud": [
          "Caída de objetos en manipulación",
          "Golpes, cortes por objetos/ herramientas",
          "Levantamiento manual de cargas",
          "Sobreesfuerzo físico"
        ],
        "medidas_de_control": [
          ["Utilizar calzado de seguridad.",true],
          ["Utilizar guantes.",true],
          ["Levantar la carga adecuadamente.",true],
          ["Cargas superiores a 23kg levantar mínimo entre dos personas.",true],
        ]
    },
    {
        "descripcion_pasos_de_tarea": "Desenrollar la fibra óptica del carrete en coche porta bobinas pequeñas",
        "riesgos_seguridad_salud": [
          "Sobreesfuerzo físico",
          "Caídas al mismo nivel"
        ],
        "medidas_de_control": [
          ["Rotar al trabajador que está realizando el desenrolle de la fibra (de ser posible).",true],
          ["Ver el lugar por donde se camina para no sufrir enredo con la fibra óptica.",true],
          ["Estar atento a la circulación de los vehículos.",true],
          ["Utilizar EPP (guantes, casco de seguridad con barbiquejo, calzado de seguridad dieléctrica, chaleco reflectivo, con cintas reflectantes color verde o naranja).",true],
        ]
    },
    {
        "descripcion_pasos_de_tarea": "Colocar y asegurar la escalera en el poste.",
        "riesgos_seguridad_salud": [
          "Golpes por herramientas/ equipos",
          "Caída de objetos en manipulación",
          "Contacto eléctrico directo",
          "Contacto eléctrico indirecto",
          "Sobreesfuerzo físico",
          "Radiación no ionizante UV"
        ],
        "medidas_de_control": [
          ["Verificar que el poste este en buen estado.",true],
          ["Asegurar o amarrar la escalera al poste.",true],
          ["Utilizar el EPP (guantes, casco de seguridad con barbiquejo, calzado de seguridad dieléctrica, chaleco reflectivo, con cintas reflectantes color verde o naranja).",true],
          ["Retirar todo tipo de objetos metálicos (aretes, cadenas, esclavas, anillos, correas con hebillas metálicas, celulares, etc.).",true],
          ["Observar que la escalera no entre en contacto o se aproxime demasiado a los cables eléctricos.",true],
          ["Manipular la escalera entre dos personas.",true],
          ["Colocar la escalera en una superficie plana, si la superficie no es plana colocar placas niveladoras.",true],
          ["Las escaleras deben tener bases prolongables.",true],
          ["Utilizar protector solar (renovar el protector cada dos a tres horas).",true],
        ]
    },
    {
        "descripcion_pasos_de_tarea": "Realizamos el tendido de fibra de poste a poste",
        "riesgos_seguridad_salud": [
          "Caída de objetos por desplome o derrumbamiento",
          "Caídas a distinto nivel",
          "Caídas en altura",
          "Caída de objetos en manipulación",
          "Golpes, cortes por objetos/ herramientas",
          "Atropello o golpe por vehículos",
          "Contacto eléctrico directo",
          "Contacto eléctrico indirecto",
          "Radiación no ionizante",
          "Posturas forzadas",
          "Sobreesfuerzo físico"
        ],
        "medidas_de_control": [
          ["Medir voltaje en las líneas eléctricas.",true],
          ["Mantener distancias de seguridad a las líneas de tensión.",true],
          ["Utilizar EPP (guantes, casco de seguridad con barbiquejo, calzado de seguridad dieléctrico, chaleco reflectivo, con cintas reflectantes color verde o naranja, arnés de seguridad 4D, línea de vida vertical, freno para línea de vida).",true],
          ["Utilizar cinturón porta herramientas.",true],
          ["Las escaleras no deben ser usadas por dos personas al mismo tiempo.",true],
          ["La distancia entre la base de la escalera y la vertical de apoyo no debe ser mayor a ¼ de la longitud de la escalera.",true],
          ["No realizar trabajos en el último peldaño de la escalera.",true],
          ["Retirar todo tipo de objetos metálicos (aretes, cadenas, esclavas, anillos, correas con hebillas metálicas, celulares, etc.).",true],
          ["Utilizar herramienta dieléctrica.",true],
          ["Utilizar protector solar (renovar el protector cada dos a tres horas).",true],
          ["Utilizar cinturón de posicionamiento.",true],
        ]
    },
    {
        "descripcion_pasos_de_tarea": "Asegura el tendido en el ingreso al domicilio del cliente",
        "riesgos_seguridad_salud": [
          "Caída de objetos por desplome o derrumbamiento",
          "Caídas a distinto nivel",
          "Caídas en altura",
          "Caída de objetos en manipulación",
          "Golpes, cortes por objetos/ herramientas",
          "Atropello o golpe por vehículos",
          "Contacto eléctrico directo",
          "Contacto eléctrico indirecto",
          "Radiación no ionizante",
          "Posturas forzadas",
          "Sobreesfuerzo físico"
        ],
        "medidas_de_control": [
          ["Medir voltaje en las líneas eléctricas.",true],
          ["Mantener distancias de seguridad a las líneas de tensión.",true],
          ["Utilizar EPP (guantes, casco de seguridad con barbiquejo, calzado de seguridad dieléctrico, chaleco reflectivo, con cintas reflectantes).",true],
          ["Las escaleras no deben ser usadas por dos personas al mismo tiempo.",true],
          ["La distancia entre la base de la escalera y la vertical de apoyo no debe ser mayor a ¼ de la longitud de la escalera.",true],
          ["No realizar trabajos en el último peldaño de la escalera.",true],
          ["Retirar todo tipo de objetos metálicos (aretes, cadenas, esclavas, anillos, correas con hebillas metálicas, celulares, etc.).",true],
          ["Utilizar herramienta dieléctrica.",true],
        ]
    },
    {
        "descripcion_pasos_de_tarea": "Instala equipos en la casa del cliente. Realiza configuración de equipos. Realiza pruebas de ancho de banda",
        "riesgos_seguridad_salud": [
          "Caída de objetos por desplome o derrumbamiento",
          "Caídas a mismo nivel",
          "Caída de objetos en manipulación",
          "Golpes, cortes por objetos/ herramientas",
          "Contacto eléctrico directo",
          "Contacto eléctrico indirecto",
          "Posturas forzadas",
          "Sobreesfuerzo físico"
        ],
        "medidas_de_control": [
          ["Medir voltaje en las líneas eléctricas.",true],
          ["Utilizar EPP (guantes, casco de seguridad con barbiquejo, calzado de seguridad dieléctrico, chaleco reflectivo, con cintas reflectantes color verde o naranja).",true],
          ["Utilizar cinturón porta herramientas.",true],
          ["Utilizar herramienta dieléctrica.",true],
        ]
    }
]

export const ATS_EQUIPOS_ELEMENTOS_CONDICIONES = {
  eec1_equipo_proteccion_personal:[
    ["Casco dieléctrico con barbiquejo",true],
    ["Calzado de seguridad dieléctrico.",true],
    ["Gafas de seguridad con protección UV",true],
    ["Guantes dieléctricos ",true],
    ["Guantes de cuero",true],
    ["Ropa de trabajo 100% algodón",true],
    ["Detector de tensión",true],
    ["Protección respiratoria",true],
    ["Protección auditiva",true],
    ["Arnés 4 anillos.",true],
    ["Línea de vida",true],
    ["Freno para línea de vida",true],
    ["Chaleco reflectivo",true],
    ["Cinturón porta herramientas",true],
    ["Herramientas dieléctricas.",true],
  ],
  eec2_equipo_medicion_proteccion:[
    ["Equipo contra incendio",true],
    ["Bloqueo/Etiquetado",true],
  ],
  eec3_equipo_complementario:[
    ["Cinta de seguridad",true],
    ["Radio transmisor y receptor",true],
  ],
  eec4_procedimiento_especifico:[
    ["Evaluación médica",true],
    ["Permiso de Trabajo",true],
  ],
}